import { z } from 'zod/v4'

export const CalendarModeSchema = z.enum(['day', 'week', 'month'])
export const CalendarWeekdaySchema = z.enum([
  'sun',
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
])

export const CalendarSyncDirectionSchema = z.enum(['push', 'pull', 'both'])

export const CalendarSyncConfigSchema = z
  .object({
    enabled: z.boolean().optional(),
    calendarIds: z.array(z.string()).optional(),
    direction: CalendarSyncDirectionSchema.optional(),
    externalReadOnly: z.boolean().optional(),
  })
  .optional()

export const CalendarConfigSchema = z.object({
  event: z.object({
    start: z.string().describe('the field handle of the start field'),
    end: z.string().optional().describe('the field handle of the end field'),
    recurrence: z
      .string()
      .optional()
      .describe('the field handle of the recurrence / RRULE field'),
    seriesId: z
      .string()
      .optional()
      .describe('the field handle of the series id / recurring event id field'),
    originalStart: z
      .string()
      .optional()
      .describe('the field handle of the original occurrence start field'),
    calendar: z
      .string()
      .optional()
      .describe('the field handle of the calendar relationship field'),
  }),

  calendarFieldMap: z
    .record(z.string(), z.string())
    .optional()
    .describe(
      'nested definition-handle to field-handle mappings on the calendar relation target',
    ),

  visibleCalendarIds: z
    .array(z.string())
    .optional()
    .describe('CRM calendar instance ids visible on this block'),

  defaultCalendarId: z
    .string()
    .optional()
    .describe(
      'CRM calendar instance id assigned when creating from this block with several calendars checked',
    ),

  /**
   * The mode of the calendar block
   */
  mode: CalendarModeSchema.optional().default('day'),

  /**
   * The weekdays of the calendar block
   */
  weekdays: z.array(CalendarWeekdaySchema).optional(),

  /**
   * time window
   */
  timeWindow: z.object({
    start: z.string().default('00:00'),
    end: z.string().default('24:00'),
    stepMinutes: z.number().int().positive().default(30),
  }),
  sync: CalendarSyncConfigSchema,
})

export type CalendarConfig = z.infer<typeof CalendarConfigSchema>
